import { Text, Image, View, Pressable } from "react-native";
import ScCheckbox from "../../ui-kit/checkbox";
import { InvitableMember } from "@/src/models/user.model";

type MemberRowProps = Readonly<{
  member: InvitableMember;
  selected: boolean;
  onToggle: () => void;
}>;

const MemberRow = ({ member, selected, onToggle }: MemberRowProps) => {
  return (
    <Pressable
      onPress={onToggle}
      className="flex-row justify-between items-center gap-3 py-3 px-1 hover:bg-ash-3 hover:rounded-lg"
    >
      <View className="flex-row gap-2 items-center">
        {member.profileImageUrl ? (
          <Image
            source={{ uri: member.profileImageUrl }}
            className="w-11 h-11 rounded-full bg-ash-3"
          />
        ) : (
          <Image
            source={require("@/src/assets/images/default-avatar.png")}
            style={{ width: 44, height: 44 }}
          />
        )}
        <View className="flex-col">
          <Text className="text-sm font-medium text-onyx">
            {member.displayName ?? member.userName}
          </Text>
          <Text className="text-xs text-gray-dark">{member.email}</Text>
        </View>
      </View>
      <ScCheckbox value={selected} onChange={onToggle} />
    </Pressable>
  );
};

export default MemberRow;
